// extracted by mini-css-extract-plugin
export default {"brandingsNew":"HsOrg","brandingLogo":"KrbDo","upgrade":"oqLGe"};